module.exports = __webpack_public_path__ + "twitter-shadow.b9ddcb6b240567632dbee4083ba1622b.svg";